<app-feature-tiles-grid data-at-dry-contact-generic-consummer>
  <ng-container *ngrxLet="deviceFeatures$ as deviceFeatures">
    <app-features-container
      [overlayType]="FeaturesDetailsOverlayTypeEnum.DryContactGenericConsumer"
      header="{{deviceFeatures.deviceName?.properties?.name?.value ?? (('+INSTALLATIONS.DRY_CONTACTS.GENERIC_CONSUMER.OTHER_DEVICE' | translate) + ' ' + deviceFeatures.deviceNumber)}}"
    >
      <!--dryContact.output.setpoint-->
      <app-feature-tile
        data-at-drycontact-output-setpoint
        *ngIf="deviceFeatures.dryContactOutputSetpoint as feature"
        isFullWidth="true"
        feature
        [value]="(feature?.properties?.active?.value ? 'GENERAL.ON' : 'GENERAL.OFF') | translate"
        [attr.data-feature]="feature.feature"
        [description]="'+INSTALLATIONS.DRY_CONTACTS.HEAT_PUMP.RECOMMENDED_STATE' | translate"
        [informationTooltip]="
          '+INSTALLATIONS.DRY_CONTACTS.GENERIC_CONSUMER.SETPOINT_TOOLTIP' | translate
        "
        [showInformationTooltip]="true"
      >
      </app-feature-tile>

      <!--dryContact.power.instantaneousPower-->
      <app-feature-tile
        data-at-drycontact-power-instantaneous-power
        *ngIf="deviceFeatures.dryContactPowerConsumption | ready as feature"
        isFullWidth="true"
        feature
        [label]="
          deviceFeatures.dryContactConsumptionStatus
            | ready
            | value2: FeaturePropertyKey.value
            | dryContactConsumptionStatus
        "
        value="{{ feature | value2: FeaturePropertyKey.value }} {{
          feature | unit: FeaturePropertyKey.value
        }}"
        [attr.data-feature]="feature.feature"
      ></app-feature-tile>
    </app-features-container>
  </ng-container>
</app-feature-tiles-grid>
